import { render, staticRenderFns } from "./InfoChange.vue?vue&type=template&id=064aae31&scoped=true&"
import script from "./InfoChange.vue?vue&type=script&lang=js&"
export * from "./InfoChange.vue?vue&type=script&lang=js&"
import style0 from "./InfoChange.vue?vue&type=style&index=0&id=064aae31&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064aae31",
  null
  
)

export default component.exports